<template>
  <div class="page-wrapper">
    <div :class="['header-wrap style4', { sticky: isSticky }]">
      <div class="header-top">
        <div class="container">
          <TopHeader />
        </div>
      </div>
      <MainNavbar />
    </div>
    <MainBanner />
    <OurFeatures />
    <AboutUs />
    <BestServices />
    <OurDepartment />
    <BookAnAppointment />
    <OurPricing />
    <GalleryExhibition />
    <OurTestimonials />
    <OurDoctors />
    <TouchWithUs />
    <LatestNews />
    <MainFooter />
  </div>
</template>

<script lang="ts">
import TopHeader from "../Layouts/TopHeader.vue";
import MainNavbar from "../Layouts/MainNavbar.vue";
import MainBanner from "../HomeEight/MainBanner.vue";
import OurFeatures from "../HomeEight/OurFeatures.vue";
import AboutUs from "../HomeEight/AboutUs.vue";
import BestServices from "../HomeEight/BestServices.vue";
import OurDepartment from "../HomeEight/OurDepartment.vue";
import BookAnAppointment from "../HomeEight/BookAnAppointment.vue";
import OurPricing from "../HomeEight/OurPricing.vue";
import GalleryExhibition from "../HomeEight/GalleryExhibition.vue";
import OurTestimonials from "../HomeEight/OurTestimonials.vue";
import OurDoctors from "../HomeEight/OurDoctors.vue";
import TouchWithUs from "../HomeEight/TouchWithUs.vue";
import LatestNews from "../HomeEight/LatestNews.vue";
import MainFooter from "../Layouts/MainFooter.vue";

import { defineComponent } from "vue";

export default defineComponent({
  name: "HomeEightPage",
  components: {
    TopHeader,
    MainNavbar,
    MainBanner,
    OurFeatures,
    AboutUs,
    BestServices,
    OurDepartment,
    BookAnAppointment,
    OurPricing,
    GalleryExhibition,
    OurTestimonials,
    OurDoctors,
    TouchWithUs,
    LatestNews,
    MainFooter,
  },
  data() {
    return {
      isSticky: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", () => {
      const scrollPos = window.scrollY;
      this.isSticky = scrollPos >= 100;
    });
  },
});
</script>